export default {
  General: {
    App: "/",
  },
  SchemaManagement: {
    Schemas: "/schemas",
    SchemaCreate: "/schemas/create",
    SchemaDetail: "/schemas/detail",
    SchemaDashboard: "/schema-dashboard",
    SchemaResults: "/schema-results",
  },
  ScheduleManagement: {
    Schedules: "/schedules",
    ScheduleCreate: "/schedules/create",
    ScheduleDetail: "/schedules/detail",
    ScheduleDashboard: "/schedule-dashboard",
    ScheduleResults: "/schedule-results",
    SurveyLinks: "/survey-links",
    Results: "/results",
    ResultCreate: "/results/create",
    ResultDetail: "/results/detail",
  },
  Report: {
    CSAT: "/report/csat",
    CSATByObject: "/report/by-object-csat",
    CSATCorp: "/report/corp-csat",
    ResultBySchema: "/report/result-by-schema",
    ResultBySchedule: "/report/result-by-schedule",
  },
  Authentication: {
    SignIn: "/sign-in",
  },
  Public: {
    FormLibrary: "/take-survey",
  },
} as const;
